import React from 'react'
import { FaBath } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { IoBedSharp } from "react-icons/io5";
import { MdOutlineSquareFoot } from "react-icons/md";
import { Link } from 'react-router-dom';

function HouseCard({ property = null }) {
    const formatRate = (rate) => rate ? `KES ${Number(rate).toLocaleString()}` : '—'
    return (
        <Link to={`/house/${property?.slug}`}>
            <article className="group cursor-pointer">
                <div className="aspect-[4/3] overflow-hidden rounded-xl bg-surface-container mb-6 perspective-card">
                    <img
                        alt={property?.title}
                        className="w-full h-full object-cover transition-transform duration-700 ease-in-out"
                        data-alt={property?.title}
                        src={property?.cover_image}
                    />
                </div>
                <div className="space-y-2">
                    <div className="flex justify-between">
                        <h3 className="font-headline font-bold text-on-surface">{property?.title}</h3>
                        <span className="text-secondary font-bold">
                            {formatRate(property?.nightly_rate)}<span className="text-xs font-normal text-on-surface-variant">/night</span>
                        </span>
                    </div>
                    <p className="text-sm text-on-surface-variant flex items-center gap-1">
                        <span className="text-sm"><FaLocationDot className='h-4 w-4 text-gray-600' /></span> {property?.area}, {property?.city}
                    </p>
                    <div className="pt-4 flex items-center gap-6 text-xs text-outline font-label uppercase tracking-tighter">
                        <span className="flex items-center gap-2"><span className=""><IoBedSharp className='h-5 w-5 text-on-surface-variant' /></span> {property?.bedrooms}</span>
                        <span className="flex items-center gap-2"><span className=""><FaBath className='h-4 w-4 text-on-surface-variant' /></span> {property?.bathrooms}</span>
                        <span className="flex items-center gap-2"><span className=""><MdOutlineSquareFoot className='h-5 w-5 text-on-surface-variant' /></span> {property?.size_sqm} sqft</span>
                    </div>
                </div>
            </article>
        </Link>
    )
}

export default HouseCard